import { Box, Typography, useTheme } from '@mui/material';

import { borderRadius } from '@verantos-dev/shared-ui-components/tokens';

/**
 * Zero-assets empty state for the project artifacts page (OR-6123 F9).
 * Its own bordered card — sitting *below* the Create button rather than
 * inside the grid's card — so a brand-new project reads as "nothing built
 * yet" rather than an empty table.
 */
export const ProjectArtifactsWelcomeCard = () => {
  const theme = useTheme();
  return (
    <Box
      data-testid="project-artifacts-welcome-state"
      sx={{
        flex: 1,
        minHeight: 0,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        textAlign: 'center',
        gap: 1,
        padding: 4,
        border: `1px solid ${theme.palette.divider}`,
        borderRadius: `${borderRadius.md}px`,
      }}
    >
      <Typography variant="h6">Welcome to your project</Typography>
      <Typography variant="body2" color="text.secondary" sx={{ maxWidth: 480 }}>
        Get started by chatting with the Research Assistant, or use the Create button to start
        building a cohort, variable, concept group, or analytical dataset.
      </Typography>
    </Box>
  );
};

export default ProjectArtifactsWelcomeCard;
